var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"scroll-button",attrs:{"dark":"","icon":""},on:{"click":_vm.onScrollButtonClick}},[_c('img',{staticClass:"scroll-btn__icon",attrs:{"src":require('@/assets/icons/arrow.svg'),"alt":"Мой профиль"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }